import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import prod2 from "../../images/cool.png";
import { Container, Spinner } from "react-bootstrap";
import ProcessedProducts from "../ExploreProducts/ProcessedProducts";
import { NavHashLink } from "react-router-hash-link";

// CategoryBanner component displays different product categories and their respective processed products
const CategoryBanner = ({ MarketCategoryType, categoryImage, title }) => {
  // Retrieve access token from local storage
  const accessToken = localStorage.getItem("GlobalAccess");

  // State variables to manage categories, active category, and loading status
  const [activeCategory, setActiveCategory] = useState(null);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true); // Tracks loading state

  // Function to handle category selection
  const handleCategoryChangeHandler = (selectedCategory) => {
    setActiveCategory(selectedCategory);
  };

  // useEffect to fetch category data when MarketCategoryType changes
  useEffect(() => {
    let isMounted = true; // Prevents state updates on unmounted components

    const getAllCategories = async () => {
      setLoading(true); // Set loading to true before fetching data

      try {
        // Construct the API URL dynamically
        const url = `${window.appConfig.getAllCategoriesBasedonCategoryTypeID}${window.appConfig.TokenRelam}/${window.appConfig.Relam}${MarketCategoryType}`;
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        };

        // Fetch category data from API
        const response = await fetch(url, { method: "GET", headers });
        const data = await response.json();

        // Update category state only if the component is still mounted
        if (isMounted) {
          setCategory(data.categoryList);
          if (data.categoryList.length > 0) {
            setActiveCategory(data.categoryList[0]); // Set the first category as active
          } else {
            console.log("No Data Found");
          }
        }
      } catch (err) {
        if (isMounted) {
          console.log("Error fetching categories:", err);
        }
      } finally {
        if (isMounted) {
          setLoading(false); // Stop loading after fetching
        }
      }
    };

    getAllCategories(); // Call the function to fetch data

    return () => {
      isMounted = false; // Cleanup function to prevent updates on unmounted components
    };
  }, [MarketCategoryType, accessToken]);

  // Function to render processed products based on selected category
  const renderProcessedProducts = () => {
    return (
      <div id="tendersContainer" className="container-fluid">
        {activeCategory && (
          <>
            {/* Display the active category title */}
            <h3 className="container-title" id={activeCategory.categoryname}>
              {activeCategory.categoryname}
            </h3>

            {/* Render ProcessedProducts component with selected category */}
            <ProcessedProducts
              key={activeCategory.categoryname}
              type={activeCategory.categoryname}
              userType={["FOOD-PROCESSOR"]}
            />
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {/* Category banner section */}
      <div className="serviceContainer ExploreBannerContainer" id="ExploreBannerContainer">
        <div className="gridSection gridSection--mmod1">
          {/* Display banner title */}
          <h2 className="container-title text-white">{title}</h2>

          {/* Show loading spinner while data is being fetched */}
          {loading ? (
            <div className="loading-container">
              <Spinner animation="border" /> Loading...
            </div>
          ) : category.length ? (
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              direction="row"
            >
              {/* Loop through categories and display them */}
              {category.map((e) => (
                <Grid
                  id="complementaryServices_link"
                  className="hoverEffect"
                  item
                  md={2}
                  sm={4}
                  xs={6}
                  key={e.categoryid}
                >
                  <NavHashLink
                    onClick={() => handleCategoryChangeHandler(e)}
                    to={`#${e.categoryname}`}
                  >
                    {/* Display category image */}
                    <img src={categoryImage[e.categoryname] || prod2} alt={e.categoryname} />
                    <h4>{e.categoryname}</h4>
                  </NavHashLink>
                </Grid>
              ))}
            </Grid>
          ) : (
            <h2>No category found</h2> // Message when no categories are available
          )}
        </div>
      </div>

      {/* Section to display processed products */}
      <div className="explore-product-wrapper">
        <Container>{renderProcessedProducts()}</Container>
      </div>
    </>
  );
};

export default CategoryBanner;
